import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import project1 from "../../assets/project1.png";
import project2 from "../../assets/project2.png";
import sol1 from "../../assets/graph1.svg";
import sol2 from "../../assets/graph2.svg";
import sol3 from "../../assets/graph3.svg";
import s1step1 from "../../assets/stage-1-1.png";
import s1step2 from "../../assets/stage-1-2.png";
import s1step3 from "../../assets/stage-1-3.png";
import s1step4 from "../../assets/stage-1-4.png";
import s1step5 from "../../assets/stage-1-5.png";
import s2step1 from "../../assets/stage-2-1.png";
import s2step2 from "../../assets/stage-2-2.png";
import s2step3 from "../../assets/stage-2-3.png";
import s2step4 from "../../assets/stage-2-4.png";
import s2step5 from "../../assets/home-stage2-step5.png";
import s3step1 from "../../assets/stage-3-1.png";
import s3step2 from "../../assets/stage-3-2.png";
import s3step3 from "../../assets/stage-3-3.png";
import s3step4 from "../../assets/stage-3-4.png";
import s3step5 from "../../assets/stage-3-5.png";
import s4step1 from "../../assets/stage-4-1.png";
import s4step2 from "../../assets/stage-4-2.png";
import s4step3 from "../../assets/stage-4-3.png";
import s4step4 from "../../assets/stage-4-4.png";
import s4step5 from "../../assets/stage-4-5.png";
import s5step1 from "../../assets/stage-5-1.png";
import s5step2 from "../../assets/stage-5-2.png";
import s5step3 from "../../assets/stage-5-3.png";
import s5step4 from "../../assets/stage-5-4.png";
import s5step5 from "../../assets/stage-5-5.png";
import s6step1 from "../../assets/stage-6-1.png";
import s6step2 from "../../assets/stage-6-2.png";
import s6step3 from "../../assets/stage-6-3.png";
import s6step4 from "../../assets/stage-6-4.png";
import s6step5 from "../../assets/home-stage6-step5.png";
import s7step1 from "../../assets/stage-7-1.png";
import s7step2 from "../../assets/stage-7-2.png";
import s7step3 from "../../assets/stage-7-3.png";
import s7step4 from "../../assets/stage-7-4.png";
import s7step5 from "../../assets/stage-7-5.png";
import s7step6 from "../../assets/stage-7-6.png";
import s8step1 from "../../assets/stage-8-1.png";
import s8step2 from "../../assets/stage-8-2.png";
import s8step3 from "../../assets/stage-8-3.png";
import s8step4 from "../../assets/stage-8-4.png";
import s8step5 from "../../assets/stage-8-5.png";
import s8step6 from "../../assets/stage-8-6.png";
import s9step1 from "../../assets/stage-9-1.png";
import s9step2 from "../../assets/stage-9-2.png";
import s9step3 from "../../assets/stage-9-3.png";
import s9step4 from "../../assets/stage-9-4.png";
import s9step5 from "../../assets/stage-9-5.png";
import s10step1 from "../../assets/stage-10-1.png";
import s10step2 from "../../assets/stage-10-2.png";
import s10step3 from "../../assets/stage-10-3.png";
import s10step4 from "../../assets/stage-10-4.png";
import s10step5 from "../../assets/stage-10-5.png";
import s10step6 from "../../assets/stage-10-6.png";
import s11step1 from "../../assets/stage-11-1.png";
import s11step2 from "../../assets/stage-11-2.png";
import s11step3 from "../../assets/stage-11-3.png";
import s11step4 from "../../assets/stage-11-4.png";
import s11step5 from "../../assets/stage-11-5.png";
import s11step6 from "../../assets/stage-11-6.png";
import s12step1 from "../../assets/stage-12-1.png";
import s12step2 from "../../assets/stage-12-2.png";
import s12step3 from "../../assets/stage-12-3.png";
import s12step4 from "../../assets/stage-12-4.png";
import s12step5 from "../../assets/stage-12-5.png";
import s12step6 from "../../assets/stage-12-6.png";
import stage2 from "../../assets/design.png";
import stage3 from "../../assets/validation.png";
import stage4 from "../../assets/eligibility.png";
import stage5 from "../../assets/solar.png";
import stage6 from "../../assets/design.png";
import stage7 from "../../assets/solar2.png";
import stage8 from "../../assets/maintainance.png";
import stage9 from "../../assets/solar.png";
import stage10 from "../../assets/training.png";
import stage11 from "../../assets/solar2.png";
import stage12 from "../../assets/solar3.png";
import homeOurSolutions1 from "../../assets/home-oursolutions-1.png";
import solar2 from "../../assets/sol-2.png";
import homeOurSolutions3 from "../../assets/home-oursolutions-3.png";
import solar4 from "../../assets/sol-4.png";
import heroOurSolutions4 from "../../assets/hero-oursolutions-4.png";
import solar5 from "../../assets/sol-5.png";
import solar6 from "../../assets/sol-6.png";
import solar7 from "../../assets/sol-7.png";
import solar8 from "../../assets/sol-8.png";
import grp1 from "../../assets/grp1.png";
import grp2 from "../../assets/grp2.png";
import searchicon from "../../assets/searchicon.svg";
import flagicon from "../../assets/flagicon.svg";
import mailicon from "../../assets/mailicon.svg";
import badgeicon from "../../assets/badgeicon.svg";
import trueRenewablesLogo from "../../assets/hiw_logo.svg";
import finalStep1 from "../../assets/finalstep1.png";
import finalStep2 from "../../assets/finalstep2.png";
import finalStep3 from "../../assets/finalstep3.png";
import heroLeft1 from "../../assets/hero-left-1.png";
import heroLeft2 from "../../assets/hero-left-2.png";
import heroLeft3 from "../../assets/hero-left-3.png";
import heroRight1 from "../../assets/hero-right-1.png";
import heroRight2 from "../../assets/hero-right-2.png";
import heroRight3 from "../../assets/hero-right-3.png";
import heroRight4 from "../../assets/hero-right-4.png";
import ecoBg from "../../assets/eco-bg.png";

const useReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        el.classList.add("is-visible");
        window.removeEventListener("scroll", check);
      }
    };

    const timer = setTimeout(() => {
      window.addEventListener("scroll", check, { passive: true });
      check();
    }, 400);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", check);
    };
  }, []);
  return ref;
};

/* ================================================
   1. ECOSYSTEM TICKER
   ================================================ */
const EcosystemTicker = () => {
  const navigate = useNavigate();
  const leftImages = [heroLeft1, heroLeft2, heroLeft3];
  const rightImages = [heroRight1, heroRight2, heroRight3, heroRight4];
  const revealRef = useReveal();

  return (
    <section className="eco-section" style={{ "--eco-bg": `url(${ecoBg})` }}>
      <div className="eco-container">
        <div className="eco-left">
          <div className="eco-left-content reveal-eco" ref={revealRef}>
            <h2 className="eco-title">
              The AI-Driven Solar Ecosystem For Industries, Government &amp;
              Homes
            </h2>
            <p className="eco-desc">
              From rooftop systems to captive plants, open access, government
              programs and carbon credits — True Renewables delivers an
              intelligent, end-to-end, zero-stress solar experience.
            </p>
            <button className="eco-btn" onClick={() => navigate("/contact")}>Book A Free Call</button>
          </div>
        </div>
        <div className="eco-right">
          <div className="eco-column eco-up">
            {[...leftImages, ...leftImages].map((img, i) => (
              <img src={img} alt="" key={`u-${i}`} />
            ))}
          </div>
          <div className="eco-column eco-down">
            {[...rightImages, ...rightImages].map((img, i) => (
              <img src={img} alt="" key={`d-${i}`} loading="lazy" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

/* ================================================
   2. OUR PHILOSOPHY
   ================================================ */
const OurPhilosophy = () => {
  const textRef = useRef(null);
  const tagRef = useReveal();

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const fullText =
      "At True Renewables, solar is more than installation—it's a long-term commitment to people, performance, and the planet. We deliver thoughtfully designed, responsibly executed systems with complete lifecycle support.";

    const words = fullText.split(" ");
    el.innerHTML = words
      .map((word) => `<span class="philo-word">${word}</span>`)
      .join(" ");

    const wordSpans = el.querySelectorAll(".philo-word");

    const onScroll = () => {
      const sectionRect = el.closest(".philo-section").getBoundingClientRect();
      const windowH = window.innerHeight;

      const progress = Math.min(
        Math.max(
          (windowH - sectionRect.top) / (windowH + sectionRect.height),
          0,
        ),
        1,
      );

      const revealCount = Math.floor(progress * wordSpans.length * 1.8);

      wordSpans.forEach((span, i) => {
        span.style.color = i < revealCount ? "#111111" : "#6D6E70";
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section className="philo-section">
      <p className="philo-tag reveal-tag" ref={tagRef}>
        <span className="philo-dot"></span> OUR PHILOSOPHY
      </p>
      {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
      <h2 className="philo-text" ref={textRef} aria-label="Our Philosophy"></h2>
    </section>
  );
};

/* ================================================
   3. OUR SOLUTIONS
   ================================================ */
const solutions = [
  {
    id: 1,
    image: homeOurSolutions1,
    title: "PM-KUSUM",
    desc: "Government-backed solar solutions enabling farmers to access clean energy and additional income.",
    path: "/pm-kusum",
  },
  {
    id: 2,
    image: solar2,
    title: "PM Surya Ghar Rooftop Yojana",
    desc: "Government-supported rooftop solar solutions for homes, reducing electricity bills and grid dependence.",
    path: "/rooftop-solar",
  },
  {
    id: 3,
    image: homeOurSolutions3,
    title: "Captive Power Model",
    desc: "Dedicated on-site solar for complete energy control and cost certainty.",
    path: "/captive-model",
  },
  {
    id: 4,
    image: heroOurSolutions4,
    title: "Group Captive Model",
    desc: "Co-own a solar power plant and collectively offtake power at significantly lower tariffs than DISCOM supply.",
    path: "/group-captive",
  },
  {
    id: 5,
    image: solar5,
    title: "Open Access Solar Model",
    desc: "Direct Access to Low-Cost Renewable Energy for C&I Consumers.",
    path: "/open-access",
  },
  {
    id: 6,
    image: solar6,
    title: "C&I Rooftop",
    desc: "Scalable solutions to cut energy costs by 30–60% for Commercial & industrial (C&I) facilities.",
    path: "/commercial-rooftop",
  },
  {
    id: 7,
    image: solar7,
    title: "Residential Rooftop",
    desc: "Designed for modern villas, independent homes, gated communities, and premium residential spaces.",
    path: "/residential-rooftop",
  },
  {
    id: 8,
    image: solar8,
    title: "Carbon Credits & Climate Assets",
    desc: "Convert your clean energy into verified carbon credits, RECs, I-RECs and ESG-ready climate assets.",
    path: "/carbon-credits",
  },
];

const OurSolutions = () => {
  const navigate = useNavigate();
  const outerRef = useRef(null);
  const trackRef = useRef(null);

  const headingRef = useRef(null);
  useEffect(() => {
    const el = headingRef.current;
    if (!el) return;

    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        el.classList.add("is-visible");
        const cards = trackRef.current?.querySelectorAll(".sol-card-animate");
        cards?.forEach((card) => card.classList.add("is-visible"));
        window.removeEventListener("scroll", check);
      }
    };

    const timer = setTimeout(() => {
      window.addEventListener("scroll", check, { passive: true });
      check();
    }, 400);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", check);
    };
  }, []);

  useEffect(() => {
    const outer = outerRef.current;
    const track = trackRef.current;
    if (!outer || !track) return;

    let current = 0;
    let target = 0;
    let raf;

    const ease = 0.12;

    const update = () => {
      current += (target - current) * ease;
      track.style.transform = `translate3d(-${current}px,0,0)`;
      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      const rect = outer.getBoundingClientRect();
      const startOffset = window.innerHeight * 0.12;
      const end = outer.offsetHeight - window.innerHeight;
      let progress = (-rect.top - startOffset) / end;
      const clamped = Math.max(0, Math.min(1, progress));
      const containerWidth = track.parentElement.offsetWidth;
      const maxTranslate = track.scrollWidth - containerWidth;
      target = clamped * maxTranslate;
    };

    window.addEventListener("scroll", onScroll);
    raf = requestAnimationFrame(update);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div className="sol-outer" ref={outerRef}>
      <div className="sol-sticky">
        <div className="sol-container">
          <div className="sol-heading reveal-block" ref={headingRef}>
            <p className="sol-label">
              <span className="sol-dot"></span> OUR SOLUTIONS
            </p>
            <h2 className="sol-title">Designed For Every Need</h2>
            <p className="sol-subtitle">
              Every solution is delivered through our unified digital ecosystem
              for complete transparency and long-term reliability.
            </p>
          </div>

          <div className="sol-track-outer">
            <div className="sol-track" ref={trackRef}>
              {solutions.map((s, i) => (
                <div
                  className="sol-card sol-card-animate"
                  key={s.id}
                  style={{ "--card-delay": `${i * 0.1}s` }}
                >
                  <div className="sol-img-wrap">
                    <img src={s.image} alt={s.title} className="sol-img" loading="lazy" />
                  </div>
                  <div className="sol-card-body">
                    <h3 className="sol-card-title">{s.title}</h3>
                    <p className="sol-card-desc">{s.desc}</p>
                    <button
                      className="sol-card-link"
                      onClick={() => navigate(s.path)}
                    >
                      EXPLORE SERVICE{" "}
                      <svg
                        width="8.67px"
                        height="8.67px"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.4 13L11 3.4V12H13V0H1V2H9.6L0 11.6L1.4 13Z"
                          fill="#f05a28"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ================================================
   3.5 DIGITAL ECOSYSTEM STACK
   ================================================ */
const ecosystemCards = [
  {
    id: 1,
    title: "TrueTrack™ — EPC Intelligence Platform",
    desc: "Real-time progress tracking, milestone management, quality assurance workflows, and client dashboards — all in one transparent EPC platform.",
    imgMain: sol1,
    imgSmall: grp1,
    path: "/truetrack",
  },
  {
    id: 2,
    title: "TrueCare™ — AI-Powered O&M & Performance Monitoring",
    desc: "IoT + SCADA monitoring, predictive maintenance, fault alerts, PR/CUF analytics, and AMC automation for maximum uptime and long-term performance.",
    imgMain: sol2,
    imgSmall: grp2,
    path: "/truecare",
  },
  {
    id: 3,
    title: "TrueCom™ — Commercial, Billing & Compliance Automation",
    desc: "Automated invoicing, open access charge reconciliation, carbon credit issuance, payment/EMI tracking, and performance dashboards.",
    imgMain: sol3,
    imgSmall: grp2,
    path: "/truecom",
  },
];

const EcosystemStack = () => {
  const navigate = useNavigate();
  const cardRefs = useRef([]);
  const rafRef = useRef(null);
  const headerRef = useReveal();
  const footerRef = useReveal();

  useEffect(() => {
    const sectionEl = cardRefs.current[0]?.closest(".stack-section");

    const update = () => {
      if (!sectionEl) return;

      const sectionRect = sectionEl.getBoundingClientRect();
      const scrolled = Math.max(0, -sectionRect.top);
      const maxScroll = Math.max(
        1,
        sectionEl.offsetHeight - window.innerHeight,
      );
      const t = Math.min(1, scrolled / maxScroll);
      const globalScale = 1 - t * 0.12;

      cardRefs.current.forEach((card) => {
        if (!card) return;
        card.style.transform = `scale(${globalScale})`;
      });

      rafRef.current = null;
    };

    const onScroll = () => {
      if (!rafRef.current) rafRef.current = requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    update();
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <section className="stack-section">
      <div className="stack-container">
        <div className="stack-header reveal-block" ref={headerRef}>
          <p className="stack-tag">
            <span className="stack-dot"></span> TRUECARE 360
          </p>
          <h2 className="stack-title">The True Digital Ecosystem</h2>
          <p className="stack-subtitle">
            Our AI-powered digital ecosystem that manages every stage of your
            solar lifecycle.
          </p>
        </div>
        <div className="stack-cards">
          {ecosystemCards.map((card, index) => (
            <div
              key={card.id}
              className="stack-card"
              style={{ top: "100px", zIndex: index + 1 }}
              ref={(el) => (cardRefs.current[index] = el)}
            >
              <div className="stack-left">
                <span className="stack-card-dot"></span>
                <div className="stack-left-inner">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                  <button
                    className="stack-btn"
                    onClick={() => navigate(card.path)}
                  >
                    Learn More
                  </button>
                </div>
                <span className="stack-card-dot"></span>
              </div>
              <div className="stack-right">
                <img
                  src={card.imgMain}
                  alt={card.title}
                  className="stack-img-main"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
        <p className="stack-footer reveal-block" ref={footerRef}>
          Together, TrueTrack™, TrueCare™ and TrueCom™ create a single source of
          truth for your entire solar journey.
        </p>
      </div>
    </section>
  );
};

/* ================================================
   4. HOW IT WORKS SECTION
   ================================================ */
const stages = [
  {
    id: 1,
    title: "Feasibility & Site Asessment",
    steps: [
      { title: "Land assessment (topography, contour, soil testing)", image: s1step1 },
      { title: "Irradiation analysis & shadow simulation", image: s1step2 },
      { title: "Grid proximity & evacuation feasibility", image: s1step3 },
      { title: "Access road & logistics evaluation", image: s1step4 },
      { title: "Preliminary DISCOM feasibility fitment", image: s1step5 },
    ],
  },
  {
    id: 2,
    title: "Design & Engineering",
    steps: [
      { title: "Plant capacity sizing (0.5–2 MW)", image: s2step1 },
      { title: "Module / inverter selection", image: s2step2 },
      { title: "Array layout & string configuration", image: s2step3 },
      { title: "SLDs, cable sizing & electrical schematics", image: s2step4 },
      { title: "Grid study & protection system planning", image: s2step5 },
    ],
  },
  {
    id: 3,
    title: "Financial Modelling",
    steps: [
      { title: "Tariff modelling & revenue forecast", image: s3step1 },
      { title: "CAPEX planning / investor structuring", image: s3step2 },
      { title: "PPA scenario planning with DISCOM", image: s3step3 },
      { title: "IRR, payback & risk mapping", image: s3step4 },
      { title: "Bankability & funding prep", image: s3step5 },
    ], 
  },
  {
    id: 4,
    title: "Documentation Prep",
    steps: [
      { title: "Land records, KYC, ownership proofs", image: s4step1 },
      { title: "CAPEX Survey documents, FMB/layout maps", image: s4step2 },
      { title: "Required DISCOM formats", image: s4step3 },
      { title: "MNRE eligibility documents", image: s4step4 },
      { title: "Draft PPA review & preparation planning / investor structuring", image: s4step5 },
    ],
  },
  {
    id: 5,
    title: "Applications & Approvals",
    steps: [
      { title: "MNRE / State portal application", image: s5step1 },
      { title: "DISCOM feasibility approval", image: s5step2 },
      { title: "CEIG/CEA compliance planning", image: s5step3 },
      { title: "Approval tracker inside TrueTrack™", image: s5step4 },
      { title: "Real-time status visible to client", image: s5step5 },],
  },
  {
    id: 6,
    title: "Engineering & Procurement",
    steps: [
      { title: "Final BOQ & vendor locking", image: s6step1 },
      { title: "Module, inverter, transformer, MMS procurement", image: s6step2 },
      { title: "Delivery schedules tracked in-app", image: s6step3 },
      { title: "Civil design, geotechnical validation", image: s6step4 },
      { title: "Digital QA of materials before dispatch", image: s6step5 },
    ],
  },
  {
    id: 7,
    title: "EPC Execution",
    steps: [
      { title: "Daily site logs: photos, videos, progress %", image: s7step1 },
      { title: "Civil, MMS, DC & AC milestones tracked digitally", image: s7step2 },
      { title: "Workfront readiness & manpower mapping", image: s7step3 },
      { title: "Material movement & consumption", image: s7step4 },
      { title: "Automated alerts for delays", image: s7step5 },
      { title: "Client dashboard: complete transparency", image: s7step6 },
    ],
  },
  {
    id: 8,
    title: "Testing & Commissioning",
    steps: [
      { title: "Module/inverter testing & safety validation", image: s8step1 },
      { title: "Transformer, HT panel, LT panel testing", image: s8step2 },
      { title: "Meter installation & DISCOM coordination", image: s8step3 },
      { title: "CEIG inspection & approvals", image: s8step4 },
      { title: "Grid synchronization and final energization", image: s8step5 },
      { title: "Handover package auto-generated", image: s8step6 },
    ],
  },
  {
    id: 9,
    title: "Live Monitoring",
    steps: [
      { title: "Real-time generation, PR, CUF & grid export", image: s9step1},
      { title: "Inverter / string-level diagnostics", image: s9step2 },
      { title: "Weather, temperature & soiling impact modeling", image: s9step3 },
      { title: "AI alerts for underperformance", image: s9step4 },
      { 
        title: "Dual dashboards:", 
        image: s9step5,
        bullets: [
          "Engineering dashboard (SCADA, granular data)",
          "Owner dashboard (simple uptime, generation, savings)"
        ]
      },
    ],
  },
  {
    id: 10,
    title: "Maintenance & Asset Health",
    steps: [
      { title: "Preventive maintenance scheduling (cleaning, tightening, vegetation)", image: s10step1 },
      { title: "Corrective maintenance with SLA-bound ticketing", image: s10step2 },
      { title: "Thermography & drone inspections", image: s10step3 },
      { title: "AC & DC side servicing logs", image: s10step4 },
      { title: "Monthly digital plant health reports", image: s10step5 },
      { title: "Downtime, root cause analysis, corrective actions", image: s10step6 },
    ],
  },
  {
    id: 11,
    title: "Billing & Settlements",
    steps: [
      { title: "Automated monthly energy billing", image: s11step1 },
      { title: "Export energy reconciliation with DISCOM", image: s11step2 },
      { title: "Payment tracking & due-date reminders", image: s11step3 },
      { title: "Revenue dashboards for investors", image: s11step4 },
      { title: "Monthly PPA performance", image: s11step5 },
      { title: "Energy accounting for audits", image: s11step6 },
    ],
  },
  {
    id: 12,
    title: "Lifecycle Reporting",
    steps: [
      { title: "Monthly & annual performance reports", image: s12step1 },
      { title: "PPA compliance documentation", image: s12step2 },
      { title: "CEIG/CEA renewal reminders", image: s12step3 },
      { title: "Data exports for banks, auditors & government", image: s12step4 },
      { title: "Carbon credit & REC eligibility mapping", image: s12step5 },
      { title: "Long-term asset performance benchmarking", image: s12step6 },
    ],
  },
];

const N = stages.length;
const RADIUS = 380; // Adjusted radius to fit text
const ANGLE_STEP = 30; // 360 / 12 items
const MINOR_TICKS = 72; // Every 5 degrees

const HowItWorks = () => {
  const sectionRef = useRef(null);

  // Refs for scroll animation
  const dialRef = useRef(null);
  const numRefs = useRef([]);
  const tickRefs = useRef([]);
  const itemRefs = useRef([]);
  const cardsContainerRef = useRef(null);
  const arcRef = useRef(null);

  // Refs for direct DOM updates (no re-renders on scroll)
  const activeStageRef = useRef(0);
  const logoRef = useRef(null);

  // React state for cards (since the number of cards changes, React state is better here for DOM structure,
  // but to keep scroll fast, we can just render enough cards and toggle their visibility).
  // Actually, we can use React state for the active index, but debounced, OR just use state directly
  // since `requestAnimationFrame` might cause too many renders.
  const [activeIdx, setActiveIdx] = useState(0);
  const [isMobilePopupOpen, setIsMobilePopupOpen] = useState(false);

  useEffect(() => {
    let raf;
    const update = () => {
      const el = sectionRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const headerEl = el.querySelector(".hiw-header-wrap");
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;

      // Start scroll after header is out of view + a 20vh delay
      const startDelay = headerHeight + window.innerHeight * 0.2;

      const totalScroll = el.offsetHeight - window.innerHeight - startDelay;
      const scrolled = -rect.top - startDelay;

      // Clamp progress between 0 and 1
      const p = Math.max(0, Math.min(scrolled / totalScroll, 1));
      const arcFloat = p * N; // Goes from 0 to 12
      const activeFloat = Math.min(arcFloat, N - 1); // Clamps at 11
      const activeIndex = Math.round(activeFloat);

      // Parent rotation
      const currentRotation = -(activeFloat * ANGLE_STEP);
      const mobileOffset = window.innerWidth <= 1024 ? -90 : 0;

      if (dialRef.current) {
        dialRef.current.style.transform = `translate(-50%, -50%) rotate(${currentRotation + mobileOffset}deg)`;
      }

      if (logoRef.current) {
        const logoOffset = window.innerWidth <= 1024 ? 90 : 0;
        logoRef.current.style.transform = `rotate(${currentRotation + logoOffset}deg)`;
      }

      // Handle opacity and keep numbers upright
      stages.forEach((_, i) => {
        const numEl = numRefs.current[i];
        const tickEl = tickRefs.current[i];
        const itemEl = itemRefs.current[i];
        if (!numEl || !tickEl || !itemEl) return;

        const dist = activeFloat - i;
        let opacity = 1;

        if (Math.abs(dist) < 0.5) {
          opacity = 0; // Hidden on dial, shown in overlay
        } else if (dist > 0.5) {
          // Past stages: fade out slowly
          opacity = Math.max(0, 1 - (dist - 0.5) * 0.4);
        } else if (dist < -5) {
          // Distant future / wrap-around: hide (don't show numbers before 1)
          opacity = 0;
        }

        numEl.style.opacity = opacity;
        tickEl.style.opacity = 1; // Keep lines always visible
        itemEl.style.opacity = opacity;

        // Keep upright: counter-rotate the itemAngle AND the dial rotation
        numEl.style.transform = `rotate(${-(i * ANGLE_STEP) - currentRotation - mobileOffset}deg)`;
      });

      // Update progression arc
      if (arcRef.current) {
        // use arcFloat so the arc completes the full circle after stage 12
        const progress = Math.max(0, Math.min(arcFloat, N)) / 12;
        const circ = 2 * Math.PI * 333;
        arcRef.current.style.strokeDashoffset = circ - progress * circ;
      }

      // Update active state if changed
      if (activeIndex !== activeStageRef.current) {
        activeStageRef.current = activeIndex;
        setActiveIdx(activeIndex); // Trigger React re-render for the cards and text
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    // Initial call
    setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  const currentStage = stages[activeIdx];
  const numStr = (activeIdx + 1).toString().padStart(2, "0");

  const cardsData = currentStage.steps;
  const stepImages = [finalStep1, finalStep2, finalStep3];

  const scrollCards = (direction) => {
    if (cardsContainerRef.current) {
      const scrollAmount = cardsContainerRef.current.offsetWidth;
      cardsContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      className="hiw-outer"
      ref={sectionRef}
      style={{ height: `${stages.length * 110}vh` }}
    >
      <div className="hiw-header-wrap">
        <div className="hiw-tag">
          <span className="hiw-dot"></span>
          HOW IT WORKS
        </div>
        <h2 className="hiw-title">
          True 360° Execution —<br />
          Zero-Stress, End-to-End Solar
        </h2>
        <p className="hiw-subtitle">
          A transparent, predictable, 12-stage execution framework that ensures
          every project — Government, Corporate or Residential — is delivered
          with absolute clarity and control.
        </p>
      </div>

      <div className="hiw-sticky">
        <div className="hiw-split">
          {/* LEFT SIDE: DIAL */}
          <div className="hiw-left">
            {/* Mobile Header (only visible on mobile to keep it sticky with the dial) */}
            <div className="hiw-mobile-header">
              <div className="hiw-tag">
                <span className="hiw-dot"></span>
                HOW IT WORKS
              </div>
              <h2 className="hiw-title">
                True 360° Execution —<br />
                Zero-Stress, End-to-End Solar
              </h2>
              <p className="hiw-subtitle">
                A transparent, predictable, 12-stage execution framework that
                ensures every project — Government, Corporate or Residential —
                is delivered with absolute clarity and control.
              </p>
            </div>

            <div className="hiw-dial-wrapper">
              <div className="hiw-dial-container" ref={dialRef}>
                <div className="hiw-dial-bg"></div>
                <div className="hiw-dial-inner-orange"></div>

                {/* Minor tick marks */}
                {Array.from({ length: MINOR_TICKS }).map((_, i) => (
                  <div
                    key={`tick-${i}`}
                    className="hiw-dial-tick-min"
                    style={{
                      transform: `rotate(${i * (360 / MINOR_TICKS)}deg) translate(${RADIUS}px)`,
                    }}
                  />
                ))}

                {/* PROGRESSION ARC */}
                <svg
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "678px",
                    height: "678px",
                    pointerEvents: "none",
                    zIndex: 2,
                  }}
                >
                  <circle
                    ref={arcRef}
                    cx="339"
                    cy="339"
                    r="333"
                    fill="none"
                    stroke="#F05A28"
                    strokeWidth="6"
                    strokeDasharray={2 * Math.PI * 333}
                    strokeDashoffset={2 * Math.PI * 333}
                    strokeLinecap="round"
                  />
                </svg>

                {/* Major Tick marks and numbers on the dial */}
                {stages.map((stage, i) => {
                  const itemAngle = i * ANGLE_STEP;
                  const isActive = i === activeIdx;
                  const isPast = i < activeIdx;

                  return (
                    <React.Fragment key={stage.id}>
                      <div
                        className={`hiw-dial-tick-maj ${isActive ? "active" : ""} ${isPast ? "past" : ""}`}
                        ref={(el) => (tickRefs.current[i] = el)}
                        style={{
                          transform: `rotate(${itemAngle}deg) translate(${RADIUS}px)`,
                        }}
                      />
                      <div
                        className={`hiw-dial-item ${isPast ? "past" : ""}`}
                        ref={(el) => (itemRefs.current[i] = el)}
                        style={{
                          transform: `rotate(${itemAngle}deg) translate(${RADIUS + 40}px)`,
                        }}
                      >
                        <div
                          className="hiw-dial-num"
                          ref={(el) => (numRefs.current[i] = el)}
                          style={{ transform: "rotate(-90deg)" }}
                        >
                          {(i + 1).toString().padStart(2, "0")}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>

              {/* FIXED INNER CIRCLE */}
              <div className="hiw-dial-inner">
                <img
                  src={trueRenewablesLogo}
                  alt="True Renewables"
                  className="hiw-center-logo"
                  ref={logoRef}
                  loading="lazy"
                />
                <div className="hiw-dial-pointer"></div>
              </div>

              {/* OVERLAY: Fixed at 3 o'clock position */}
              <div className="hiw-active-overlay">
                <div className="hiw-inner-faint-line"></div>
                <div className="hiw-active-thick-line"></div>
                <div className="hiw-active-dot"></div>
                <div className="hiw-active-text-block">
                  <span className="hiw-active-num">{numStr}</span>
                  <span className="hiw-active-title">{currentStage.title}</span>
                </div>
              </div>
            </div>
            {/* Mobile info block (only visible on mobile) */}
            <div className="hiw-mobile-info">
              <div className="hiw-mobile-stage">STAGE {activeIdx + 1}</div>
              <h3 className="hiw-mobile-title">{currentStage.title}</h3>
              <p className="hiw-mobile-desc">
                {currentStage.steps.map((s) => s.title).join(", ")}
              </p>
              <button
                className="hiw-mobile-view-btn"
                onClick={() => {
                  console.log("View Details clicked!");
                  setIsMobilePopupOpen(true);
                }}
              >
                VIEW DETAILS ↗
              </button>
            </div>
          </div>

          {/* RIGHT SIDE: CONTENT */}
          <div
            className={`hiw-right ${isMobilePopupOpen ? "mobile-open" : ""}`}
          >
            <div
              className="hiw-popup-bg"
              onClick={() => setIsMobilePopupOpen(false)}
            ></div>
            <div className="hiw-popup-inner">
              <button
                className="hiw-popup-close"
                onClick={() => setIsMobilePopupOpen(false)}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div className="hiw-stage-badge">STAGE {numStr}</div>
              <h2 className="hiw-right-title">{currentStage.title}</h2>

              <div className="hiw-cards-container" ref={cardsContainerRef}>
                {cardsData.map((step, idx) => (
                  <div key={idx} className="hiw-step-card">
                    <div className="hiw-step-img-wrap">
                      <img
                        src={step.image}
                        alt={step.title}
                        className="hiw-step-img"
                        loading="lazy"
                      />
                    </div>
                    <div className="hiw-step-text">
                      <p className="hiw-step-num">STEP {idx + 1}</p>
                      <h4 className="hiw-step-title">{step.title}</h4>
                      {step.bullets && (
                        <ul className="hiw-step-bullets">
                          {step.bullets.map((bullet, i) => (
                            <li key={i} className="hiw-step-bullet">{bullet}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="hiw-nav-arrows">
                <button
                  type="button"
                  className="hiw-nav-arrow"
                  onClick={() => scrollCards("left")}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                <button
                  type="button"
                  className="hiw-nav-arrow"
                  onClick={() => scrollCards("right")}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>

              {/* Mobile duplicated stage info for the bottom of the popup */}
              <div className="hiw-popup-mobile-info">
                <div className="hiw-mobile-stage">STAGE {activeIdx + 1}</div>
                <h3 className="hiw-mobile-title">{currentStage.title}</h3>
                <p className="hiw-mobile-desc">
                  {currentStage.steps.map((s) => s.title).join(", ")}
                </p>
                <button
                  className="hiw-mobile-view-btn popup-btn"
                  onClick={() => setIsMobilePopupOpen(false)}
                >
                  VIEW DETAILS ↗
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ================================================
   3.8 IMPACT STATS (WHY CHOOSE US)
   ================================================ */
const statsData = [
  {
    id: 1,
    label: "MW Solar Capacity Installed",
    value: 120,
    suffix: "+",
    color: "blue",
  },
  {
    id: 2,
    label: "Tonnes of CO₂ Emissions Reduced",
    value: 25,
    suffix: "+",
    color: "orange",
  },
  {
    id: 3,
    label: "Successful Projects Delivered",
    value: 99,
    suffix: "%",
    color: "blue",
  },
  {
    id: 4,
    label: "Years of Industry Experience",
    value: 10,
    suffix: "+",
    color: "orange",
  },
];

const ImpactStats = () => {
  const sectionRef = useRef(null);
  const headerRef = useReveal();
  const [visible, setVisible] = useState(false);
  const [counts, setCounts] = useState(statsData.map(() => 0));
  const animatingRef = useRef(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        setCounts(statsData.map(() => 0));
        animatingRef.current = false;
        setVisible(true);
        el.classList.add("is-visible");
        window.removeEventListener("scroll", check);
      }
    };

    const timer = setTimeout(() => {
      window.addEventListener("scroll", check, { passive: true });
      check();
    }, 400);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", check);
    };
  }, []);

  useEffect(() => {
    if (!visible || animatingRef.current) return;
    animatingRef.current = true;

    statsData.forEach((stat, index) => {
      let start = 0;
      const end = stat.value;
      const stepTime = 20;
      const increment = end / (1500 / stepTime);

      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          start = end;
          clearInterval(timer);
        }
        setCounts((prev) => {
          const copy = [...prev];
          copy[index] = Math.floor(start);
          return copy;
        });
      }, stepTime);
    });
  }, [visible]);

  return (
    <section className="impact-section" ref={sectionRef}>
      <div className="impact-container reveal-block" ref={headerRef}>
        <div className="impact-left">
          <p className="impact-tag">
            <span className="impact-dot"></span> WHY CHOOSE US
          </p>
          <h2 className="impact-title">
            Built For Performance.
            <br />
            Proven By Impact.
          </h2>
        </div>
        <div className="impact-right">
          <p className="impact-desc">
            True Renewables goes beyond just installing solar panels — we take
            complete ownership of your clean-energy journey. Our approach is
            built on TRUE Care 360, ensuring every project is carefully planned,
            transparently executed, and supported long after installation.
          </p>
        </div>
      </div>
      <div className="impact-stats">
        {statsData.map((stat, index) => (
          <div
            key={stat.id}
            className="impact-card impact-card-animate"
            style={{ "--stat-delay": `${index * 0.12}s` }}
          >
            <p className="impact-label">{stat.label}</p>
            <h3
              className={`impact-number ${stat.color === "orange" ? "orange" : "blue"}`}
            >
              {counts[index]}
              {stat.suffix}
            </h3>
          </div>
        ))}
      </div>
    </section>
  );
};

/* ================================================
   4. FEATURED PROJECTS
   ================================================ */
const projects = [
  {
    id: 1,
    image: project1,
    title: "Industrial Captive Solar Plant",
    desc: "Designed for high-performance output with AI-led monitoring and long-term reliability.",
    tags: ["CAPTIVE", "120 MW"],
  },
  {
    id: 2,
    image: project2,
    title: "Rooftop Solar For Urban Communities",
    desc: "Clean, cost-efficient energy with seamless approvals and lifecycle support.",
    tags: ["ROOFTOP", "30 kW"],
  },
];

const FeaturedProjects = () => {
  const headerRef = useReveal();
  const card1Ref = useReveal();
  const card2Ref = useReveal();

  return (
    <section className="proj-section">
      <div className="proj-header reveal-block" ref={headerRef}>
        <p className="proj-tag">
          <span className="proj-dot"></span> FEATURED PROJECTS
        </p>
        <h2 className="proj-title">Projects That Power Real Impact</h2>
      </div>
      <div className="proj-cards">
        {projects.map((p, i) => (
          <div
            className="proj-card reveal-slide-up"
            key={p.id}
            ref={i === 0 ? card1Ref : card2Ref}
            style={{ "--proj-delay": `${i * 0.15}s` }}
          >
            <div className="proj-img-wrap">
              {p.image ? (
                <img src={p.image} alt={p.title} className="proj-img" loading="lazy" />
              ) : (
                <div className="proj-img-placeholder" />
              )}
            </div>
            <div className="proj-card-body">
              <h3 className="proj-card-title">{p.title}</h3>
              <p className="proj-card-desc">{p.desc}</p>
              <div className="proj-tags">
                {p.tags.map((tag) => (
                  <span className="proj-tag-pill" key={tag}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

/* ================================================
   6. ABOUT
   ================================================ */
const HomeAbout = () => {
  const leftRef = useReveal();
  const rightRef = useReveal();

  return (
    <section className="about-section">
      <div className="about-left reveal-from-left" ref={leftRef}>
        <p className="about-tag">
          <span className="testi-dot"></span> ABOUT US
        </p>
        <h2 className="about-title">
          Not Just EPC. An Intelligent
          <br />
          Solar Ecosystem.
        </h2>
        <p className="about-desc">
          Built like a tech company—AI-driven, digital-first, and engineered for
          long-term performance and transparency.
        </p>
        <button className="about-btn">Learn More</button>
      </div>
      <div className="about-right" ref={rightRef}>
        {[
          {
            icon: searchicon,
            title: "AI-Driven Monitoring",
            desc: "Real-time insights, automated alerts, and data intelligence for maximum performance.",
          },
          {
            icon: flagicon,
            title: "Digital EPC Execution with TrueTrack™",
            desc: "Transparent milestone tracking and project intelligence for stress-free execution.",
          },
          {
            icon: mailicon,
            title: "Automated Billing, Compliance & Carbon Reporting",
            desc: "TrueCom™ ensures all financial, regulatory and carbon workflows are fully automated.",
          },
          {
            icon: badgeicon,
            title: "Premium Engineering Standards",
            desc: "Tier-I technology, advanced safety protocols and future-proof system design.",
          },
        ].map((card, i) => (
          <div
            className="about-card about-card-animate"
            key={i}
            style={{ "--about-delay": `${i * 0.1}s` }}
          >
            <div className="about-card-icon-wrap">
              <img src={card.icon} alt="" className="about-card-icon" loading="lazy" />
            </div>
            <h4>{card.title}</h4>
            <p>{card.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

/* ================================================
   HOME — all sections
   ================================================ */
const Home = () => (
  <>
    <EcosystemTicker />
    <OurPhilosophy />
    <OurSolutions />
    <EcosystemStack />
    <HowItWorks />
    <ImpactStats />
    <FeaturedProjects />
    <HomeAbout />
  </>
);

export default Home;
